module.exports = __webpack_public_path__ + "img/Overlay.e3db751c.svg";